// auth/components/LoginComponent.jsx

import { useState } from 'react';
import { useAuth } from '../authContext';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { consumePostAuthRedirect } from '../postAuthRedirect';

const LoginComponent = ({ onRequestClose, openSignUpModal }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [forgotPassword, setForgotPassword] = useState(false);
  const [resetLinkSent, setResetLinkSent] = useState(false);
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (forgotPassword) {
      try {
        await axios.post(`${apiUrl}/users/password-reset`, { email: formData.email });
        setMessage(t('password_reset_email_sent'));
        setError('');
        setResetLinkSent(true);
      } catch (error) {
        console.error('Error sending password reset email:', error);
        setError(t('password_reset_email_error'));
        setMessage('');
      }
    } else {
      const email = (formData.email || '').trim().toLowerCase();
      try {
        await auth.login(email, formData.password);
      } catch (error) {
        console.error('Login error:', error);
        setError(t('login_failed'));
        setMessage('');
        return;
      }

      setMessage(t('login_successful'));
      setError('');

      if (onRequestClose) onRequestClose();
      navigate(consumePostAuthRedirect(location.state), { replace: true });
    }
  };

  return (
    <div className="web-modal-form">
      {error && <p className="web-modal-error">{error}</p>}
      {message && <p style={{ color: 'green', textAlign: 'center' }}>{message}</p>}

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder={t('email')}
          className="web-modal-input"
          required
        />

        {!forgotPassword && (
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder={t('password')}
            className="web-modal-input"
            required
          />
        )}

        <button type="submit" className="web-modal-button" style={{ width: '100%', marginTop: '1rem' }}>
          {forgotPassword ? t('send_reset_link') : t('login')}
        </button>
      </form>

      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        {!forgotPassword ? (
          <>
            <button
              onClick={() => setForgotPassword(true)}
              className="web-modal-button--link"
            >
              {t('forgot_password')}
            </button>
            <br />
            {openSignUpModal ? (
              <button
                onClick={openSignUpModal}
                className="web-modal-button--link"
                style={{ marginTop: '6px' }}
              >
                {t('need_an_account_sign_up')}
              </button>
            ) : (
              <a
                href="/signup"
                className="web-modal-button--link"
                style={{ display: 'inline-block', marginTop: '6px' }}
              >
                {t('need_an_account_sign_up')}
              </a>
            )}
          </>
        ) : (
          <>
            {resetLinkSent ? (
              <p>{t('password_reset_email_sent')}</p>
            ) : (
              <button
                onClick={() => setForgotPassword(false)}
                className="web-modal-button--link"
              >
                {t('return_to_login')}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default LoginComponent;
